module.exports = __webpack_public_path__ + "img/phoneline.8f49c04b.svg";